/**
 * Created by pawel on 2017-03-15.
 */
;(function() {
    $(document).on('keyup', 'textarea[data-auto-resize]', function (e) {
        var ui = $(this), b, h;
        if(ui.attr('data-auto-resize')) {
            console.log('data-auto-resize');
            if (!ui.prop('scrollTop')) {
                do {
                    b = ui.prop('scrollHeight');
                    h = ui.height();
                    ui.height(h - 5);
                }
                while (b && (b != ui.prop('scrollHeight')));
            }
            ui.height( ui.prop('scrollHeight') + 0);
        }
    });
    setTimeout(function () {
        $('textarea[data-auto-resize]').trigger('keyup');
    },500);

})(jQuery);